export function normalizeUiMode(uiMode?: string): string {
  const normalizedMode = uiMode?.trim().toLowerCase() || 'authorization';
  if (normalizedMode === 'appeals') return 'complaint';
  if (normalizedMode === 'authorizations') return 'authorization';
  return normalizedMode;
}
